import { ConvexReactClient } from 'convex/react';

const convexUrl = process.env.REACT_APP_CONVEX_URL;

if (!convexUrl) {
  console.warn('⚠️ REACT_APP_CONVEX_URL is not set. Convex client will not work.');
}

// Initialize Convex client
export const convex = new ConvexReactClient(convexUrl || 'https://placeholder.convex.cloud', {
  unsavedChangesWarning: false,
});

export default convex;





